import { render } from "./WalletDashboard.vue?vue&type=template&id=260432b1&scoped=true"
import script from "./WalletDashboard.vue?vue&type=script&lang=js"
export * from "./WalletDashboard.vue?vue&type=script&lang=js"

import "./WalletDashboard.vue?vue&type=style&index=0&id=260432b1&scoped=true&lang=css"
import "./WalletDashboard.vue?vue&type=style&index=1&id=260432b1&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260432b1"]])

export default __exports__